import React from "react"

export default function Bell() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <g clipPath="url(#clip0_0_4)">
        <path d="M9 16.5C9.825 16.5 10.5 15.825 10.5 15H7.5C7.5 15.825 8.1675 16.5 9 16.5ZM13.5 12V8.25C13.5 5.9475 12.27 4.02 10.125 3.51V3C10.125 2.3775 9.6225 1.875 9 1.875C8.3775 1.875 7.875 2.3775 7.875 3V3.51C5.7225 4.02 4.5 5.94 4.5 8.25V12L3.5325 12.9675C3.06 13.44 3.39 14.25 4.0575 14.25H13.935C14.6025 14.25 14.94 13.44 14.4675 12.9675L13.5 12Z" fill="#5B5E71" />
      </g>
      <defs>
        <clipPath id="clip0_0_4">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}